import { Component, Input, OnInit, HostBinding } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NbDialogRef, NbCardModule, NbAccordionModule, NbCheckboxModule, NbButtonModule, NbSpinnerModule } from '@nebular/theme';
import { Category } from '../../../../model/category.model';
import { ProductsService } from '../../../../service/product.service';
import { Product } from '../../dashboard/product.store';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-backup-selection-modal',
    templateUrl: './backup-selection-modal.component.html',
    styleUrls: ['./backup-selection-modal.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        NbCardModule,
        NbAccordionModule,
        NbCheckboxModule,
        NbButtonModule,
        NbSpinnerModule
    ]
})
export class BackupSelectionModalComponent implements OnInit {

    @Input() categories: Category[] = [];
    @Input() metaCategoryId!: number;
    @Input() preSelectedProductIds: string[] = [];

    @HostBinding('class.loaded') isLoaded = false;

    selectedProductIds: Set<string> = new Set();
    productsByCategory: Map<number, Product[]> = new Map();
    loadingCategories: Set<number> = new Set();

    constructor(
        protected ref: NbDialogRef<BackupSelectionModalComponent>,
        private productsService: ProductsService
    ) { }

    ngOnInit(): void {
        console.log('BackupSelectionModalComponent initialized', {
            categories: this.categories,
            metaCategoryId: this.metaCategoryId,
            preSelectedProductIds: this.preSelectedProductIds
        });
        this.selectedProductIds = new Set(this.preSelectedProductIds);
        setTimeout(() => {
            this.isLoaded = true;
        });
    }

    onCategoryExpand(category: Category, expanded: boolean) {
        console.log('onCategoryExpand', { categoryId: category.id, expanded, hasProducts: this.productsByCategory.has(category.id) });
        if (expanded && !this.productsByCategory.has(category.id)) {
            this.loadProducts(category.id);
        }
    }

    loadProducts(categoryId: number) {
        console.log('loadProducts called', { categoryId, metaCategoryId: this.metaCategoryId });
        if (this.metaCategoryId === undefined || this.metaCategoryId === null) {
            console.error('MetaCategory ID is missing');
            return;
        }

        this.loadingCategories.add(categoryId);
        // Using getProduct from ProductsService. 
        // Signature: getProduct(categoryId, metaCategoryId, page, filter, sort, searchTerm, exclude_ids, ...)
        // We'll fetch the first page or all? TableComponent uses pagination. 
        // For backup selection, maybe we want "best sellers" or just default order.
        // Let's fetch page 1 (50 items usually) which should be enough for backups? 
        // Or implement 'load more'. For now simple page 1.

        this.productsService.getProduct(
            categoryId,
            this.metaCategoryId,
            1, // page (0 probably means no explicit page or all? TableComponent says page 1 starts at 1 usually but sends 0 in some calls?) 
            // Check TableComponent: it calls with 0 in loadAllProductsForCategory line 362.
            null,
            { key: 'ventes', direction: 'DESC' },
            null
        ).pipe(
            take(1)
        ).subscribe({
            next: (products: Product[]) => {
                console.log('Products loaded for category', categoryId, products);
                this.productsByCategory.set(categoryId, products);
                this.loadingCategories.delete(categoryId);
            },
            error: (err) => {
                console.error('Error loading products', err);
                this.loadingCategories.delete(categoryId);
            }
        });
    }

    toggleProduct(product: Product) {
        if (this.selectedProductIds.has(product.product_id)) {
            this.selectedProductIds.delete(product.product_id);
        } else {
            this.selectedProductIds.add(product.product_id);
        }
    }

    submit() {
        this.ref.close(Array.from(this.selectedProductIds));
    }

    cancel() {
        this.ref.close();
    }
}
